










































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as AppModal from "@/AppModal";

export default defineComponent({

	emits:[],
	props:{
		value:{
			type:String,
			default:"name",
		},
	},
	components:{
	},
	setup(props, context){
		
		const selectedLabel = computed(() => {

			return sortOptions.value.find(o => o.value === props.value)?.text || "-";

		});
		
		const sortOptions = computed(() => {
			return [
				{ value: "name", text: "Name" },
				{ value: "lastModified", text: "Modified" },
			]
		});

		const openMenu = (e:Event) => {
			AppModal.context(e, sortOptions.value.map(o => {
				return {
					name:o.text,
					icon:props.value === o.value ? "mdi.check" : "",
					fn(){
						context.emit("input", o.value);
					}
				}
			}))
		};

		return {
			sortOptions,
			openMenu,
			selectedLabel,
		};
	}
});

